var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Menu',{attrs:{"mode":"horizontal","theme":"light","active-name":"home"}},[_c('div',{staticClass:"container"},[_c('a',{attrs:{"href":"#/","target":"_self"}},[_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/img/logo2.png")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }